import { IBroker } from "../../models/IBroker";

export class BrokerState {
  brokersList: IBroker[] = [];
}
